import React, { FunctionComponent, memo } from 'react';

import { urls } from '@flowgate/core/assets/app';

import { SvgProps } from './types';

const Svg: FunctionComponent<SvgProps> = props => {
  const style = {
    width: props.size || props.width,
    height: props.size || props.height,
    transform: props.rotation ? `rotate(${props.rotation}deg)` : undefined,
    transition: 'transform .2s ease-in-out',
  };
  return (
    <svg
      className={`svg svg--${props.type || 'icons'} svg--${props.symbol}`}
      style={style}
    >
      <use xlinkHref={`${props.url || urls.icons}#${props.symbol}`} />
    </svg>
  );
};

export default memo<SvgProps>(Svg);
